import { Component, inject } from '@angular/core';
import { BLUETOOTH_PASSKEY_LENGTH, SERIAL_NUMBER_LENGTH } from '../../app.constants';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'app-charger-add-dialog',
	imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, ReactiveFormsModule],
	templateUrl: './charger-add-dialog.component.html',
	styleUrl: './charger-add-dialog.component.scss'
})
export class ChargerAddDialogComponent {
	private readonly fb = inject(FormBuilder);
	private readonly dialogRef = inject(MatDialogRef<ChargerAddDialogComponent>);

	readonly serialNumberLength = SERIAL_NUMBER_LENGTH;
	readonly bluetoothPasskeyLength = BLUETOOTH_PASSKEY_LENGTH;

	form = this.fb.nonNullable.group({
		serialNumber: this.fb.nonNullable.control('', [
			Validators.required,
			Validators.minLength(this.serialNumberLength),
			Validators.maxLength(this.serialNumberLength),
			Validators.pattern(/^[PD]\d{14}$/), // P or D with 14 digits
		]),
		bluetoothPasskey: this.fb.nonNullable.control('', [
			Validators.required,
			Validators.minLength(this.bluetoothPasskeyLength),
			Validators.maxLength(this.bluetoothPasskeyLength),
			Validators.pattern(/^\d{6}$/), // 6 digits
		]),
	});

	cancel() {
		this.dialogRef.close();
	}

	add() {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}

		const { serialNumber, bluetoothPasskey } = this.form.getRawValue();
		this.dialogRef.close({
			serialNumber: serialNumber,
			bluetoothPasskey: bluetoothPasskey,
		});
	}
}
